import { render, staticRenderFns } from "./FarmV2.vue?vue&type=template&id=43167bcd&scoped=true&"
import script from "./FarmV2.vue?vue&type=script&lang=js&"
export * from "./FarmV2.vue?vue&type=script&lang=js&"
import style0 from "./FarmV2.vue?vue&type=style&index=0&id=43167bcd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43167bcd",
  null
  
)

export default component.exports